module.exports = "<p>My great-grandparents immigrated from Ukraine to Canada, and I want to draw your attention to the artwork of <a href=https://www.wikiart.org/en/maria-primachenko/all-works#!#filterName:all-paintings-chronologically,resultType:masonry>Maria Prymachenko</a>.&nbsp; Her titles alone are their own art.&nbsp; Art can be physically burned, but only symbolically destroyed.</p> ";


//////////////////
// WEBPACK FOOTER
// ./application/text/ukraine.md
// module id = 557
// module chunks = 0